import { BookOpen } from 'lucide-react';
import './ManualLink.css';

export default function ManualLink() {
  const handleOpenManual = () => {
    window.open('/manual.pdf', '_blank');
  };

  return (
    <button className="manual-link" onClick={handleOpenManual}>
      <BookOpen size={20} />
      <span>操作マニュアル</span>
    </button>
  );
}
